<div class="max-w-5xl mx-auto text-left">
    <div class="flex flex-wrap items-center justify-between gap-3 py-4">
        <p class="text-gray-800">
            Вкупно: {{ reviews.length }} · <strong>Чекаат одобрување: {{ pendingCount }}</strong>
        </p>
        <button type="button" class="rounded bg-primaryDark px-5 py-2 font-medium text-white hover:bg-primaryDarker"
                (click)="startAdd()">Додади мислење (Facebook, Viber…)
        </button>
    </div>

    @if (error) {
        <p class="mb-3 rounded bg-red-50 border border-red-200 px-4 py-2 text-red-700" role="alert">{{ error }}</p>
    }

    @if (showForm) {
        <form class="mb-6 grid gap-3 rounded-lg border border-gray-300 bg-gray-50 p-4 md:grid-cols-2"
              [formGroup]="form" (ngSubmit)="save()" novalidate>
            <h3 class="md:col-span-2 font-medium">{{ editingId ? 'Уреди мислење' : 'Ново мислење' }}</h3>
            <p class="md:col-span-2 text-sm text-gray-600">
                Внесувајте само вистински мислења од купувачи, со нивното име како што е напишано и изворот.
            </p>

            <label class="block text-sm">Производ
                <select class="mt-1 block w-full rounded border border-gray-300 px-2 py-2" formControlName="productId">
                    <option [ngValue]="null">Продавницата (општо)</option>
                    @for (product of products; track product.id) {
                        <option [ngValue]="product.id">{{ product.name }}</option>
                    }
                </select>
            </label>

            <label class="block text-sm">Извор
                <select class="mt-1 block w-full rounded border border-gray-300 px-2 py-2" formControlName="source">
                    @for (source of sources; track source) {
                        <option [ngValue]="source">{{ sourceLabels[source] }}</option>
                    }
                </select>
            </label>

            <label class="block text-sm">Име
                <input class="mt-1 block w-full rounded border border-gray-300 px-2 py-2" formControlName="authorName" maxlength="60">
            </label>

            <label class="block text-sm">Град
                <input class="mt-1 block w-full rounded border border-gray-300 px-2 py-2" formControlName="city" maxlength="60">
            </label>

            <label class="block text-sm">Оценка
                <select class="mt-1 block w-full rounded border border-gray-300 px-2 py-2" formControlName="rating">
                    @for (value of [5, 4, 3, 2, 1]; track value) {
                        <option [ngValue]="value">{{ value }} ★</option>
                    }
                </select>
            </label>

            <label class="block text-sm">Датум на коментарот
                <input class="mt-1 block w-full rounded border border-gray-300 px-2 py-2" type="date" formControlName="createdAt">
            </label>

            <label class="block text-sm md:col-span-2">Текст
                <textarea class="mt-1 block w-full rounded border border-gray-300 px-2 py-2" rows="4" formControlName="text" maxlength="2000"></textarea>
            </label>

            <label class="block text-sm">Телефон (не се објавува)
                <input class="mt-1 block w-full rounded border border-gray-300 px-2 py-2" formControlName="phoneNumber" maxlength="40">
            </label>

            <div class="flex flex-col justify-end gap-2 text-sm">
                <label class="flex items-center gap-2">
                    <input type="checkbox" formControlName="verifiedPurchase"> Потврден купувач
                </label>
                <label class="flex items-center gap-2">
                    <input type="checkbox" formControlName="approved"> Прикажи на сајтот
                </label>
            </div>

            <div class="md:col-span-2 flex gap-3">
                <button type="submit" class="rounded bg-primaryDark px-5 py-2 font-medium text-white hover:bg-primaryDarker disabled:opacity-60"
                        [disabled]="saving">{{ saving ? 'Се зачувува…' : 'Зачувај' }}</button>
                <button type="button" class="underline text-gray-600" (click)="showForm = false">Откажи</button>
            </div>
        </form>
    }

    <ul class="space-y-3 list-none p-0">
        @for (review of reviews; track review.id) {
            <li class="rounded-lg border p-4" [class.border-yellow-400]="!review.approved" [class.bg-yellow-50]="!review.approved">
                <div class="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm">
                    <app-star-rating [rating]="review.rating"></app-star-rating>
                    <strong>{{ review.authorName }}</strong>
                    @if (review.city) {
                        <span>{{ review.city }}</span>
                    }
                    <span class="text-gray-500">{{ review.createdAt | date:'d.M.yyyy' }}</span>
                    <span class="text-gray-500">{{ sourceLabels[review.source] }}</span>
                    @if (review.verifiedPurchase) {
                        <span class="text-primaryDark font-medium">✓ потврден купувач</span>
                    }
                    @if (!review.approved) {
                        <span class="rounded bg-yellow-200 px-2 text-yellow-900">Чека одобрување</span>
                    }
                </div>
                <p class="pt-1 text-sm text-gray-600">{{ productName(review.productId) }}
                    @if (review.phoneNumber) {
                        · тел. {{ review.phoneNumber }}
                    }
                </p>
                <p class="pt-2 whitespace-pre-line">{{ review.text }}</p>
                <div class="pt-3 flex flex-wrap gap-3 text-sm">
                    <button type="button" class="rounded px-3 py-1 font-medium text-white"
                            [class.bg-primaryDark]="!review.approved" [class.bg-gray-500]="review.approved"
                            (click)="toggleApproved(review)">{{ review.approved ? 'Сокриј' : 'Одобри' }}</button>
                    <button type="button" class="underline" (click)="startEdit(review)">Уреди</button>
                    <button type="button" class="underline text-red-600" (click)="remove(review)">Избриши</button>
                </div>
            </li>
        } @empty {
            <li class="text-gray-600">Сè уште нема мислења.</li>
        }
    </ul>
</div>
